import { ENDPOINTS } from "src/api/endpoints";

export const getIsAdmin = async (headers: {
  Authorization: string;
}): Promise<boolean> => {
  try {
    const response = await fetch(ENDPOINTS.IS_ADMIN, {
      method: "GET",
      headers: {
        ...headers,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to get user admin: ${response.status} ${response.statusText}`
      );
    }

    const data = (await response.json()) as boolean;
    return data;
  } catch (error) {
    console.error("Error getting user subscription:", error);
    throw error;
  }
};
